import { render, staticRenderFns } from "./TicketConversationPanel.vue?vue&type=template&id=038d97f7&scoped=true&"
import script from "./TicketConversationPanel.vue?vue&type=script&lang=js&"
export * from "./TicketConversationPanel.vue?vue&type=script&lang=js&"
import style0 from "./TicketConversationPanel.vue?vue&type=style&index=0&id=038d97f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d97f7",
  null
  
)

export default component.exports